import React, { Component } from 'react'
import style from './style.css'
export default class MessageFooter extends Component {
    render() {
        return (
            <div className={`${style.message} ${style.danger}`}>
                {this.props.children}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/App/Components/MessageFooter/index.js